import _ from 'lodash';
import { lsApiService } from 'ls-vue-common';
import {
    FEATURE_FLAGS__MUTATE_FLAGS,
    FEATURE_FLAGS__GET_FLAGS,
    FEATURE_FLAGS__REGISTER_EXPOSURE,
    FEATURE_FLAGS__ALL_FLAGS,
    ERROR__SET_ERROR,
} from '../types';

const FLAGS_CACHE_KEY = 'ls.flags.cache';
const FLAGS_CACHED_AT_KEY = 'ls.flags.cached_at';

// 1 hour in milliseconds
const FLAGS_CACHE_TTL = 3600 * 1000;

const createInitialState = () => ({
    flags: {},
});

function getFlagsCache() {
    const flagsCache = window.localStorage.getItem(FLAGS_CACHE_KEY);
    return JSON.parse(flagsCache);
}

function isFlagsCacheExpired() {
    const now = new Date();
    const flagsCachedAt = window.localStorage.getItem(FLAGS_CACHED_AT_KEY);
    return flagsCachedAt ? now.getTime() - flagsCachedAt > FLAGS_CACHE_TTL : true;
}

function setFlagsCache(data) {
    const now = new Date();
    window.localStorage.setItem(FLAGS_CACHE_KEY, JSON.stringify(data));
    window.localStorage.setItem(FLAGS_CACHED_AT_KEY, now.getTime());
}

export const mutations = {
    [FEATURE_FLAGS__MUTATE_FLAGS](state, payload) {
        _.assign(state.flags, payload);
    },
};

export const actions = {
    [FEATURE_FLAGS__GET_FLAGS]({ commit, dispatch }) {
        if (!isFlagsCacheExpired()) {
            commit(FEATURE_FLAGS__MUTATE_FLAGS, getFlagsCache());
            return;
        }
        lsApiService
            .request({
                route: '/flags',
            })
            .then(({ data }) => {
                setFlagsCache(data);
                commit(FEATURE_FLAGS__MUTATE_FLAGS, data);
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            });
    },

    [FEATURE_FLAGS__REGISTER_EXPOSURE]({ dispatch, state }, { flag }) {
        if (_.isNull(_.get(state.flags, `${flag}`, null))) {
            return;
        }

        // eslint-disable-next-line consistent-return
        return lsApiService
            .request({
                route: `/flags/${flag}`,
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            });
    },
};

export const getters = {
    [FEATURE_FLAGS__ALL_FLAGS](state) {
        return state.flags;
    },
};

export const featureFlags = {
    state: createInitialState,
    mutations,
    actions,
    getters,
};
